import { getEntity } from "./getEntity";
import { MENU } from "../constants";

export const CONTACT_MENU_ENTITY_ID = "4";

export const isContactMenuVisible = (): boolean =>
  getEntity().id === CONTACT_MENU_ENTITY_ID;

export const CARD_RECHARGE_ENTITY_ID = "4";

export const isCardRechargeVisible = (): boolean =>
  getEntity().id === CARD_RECHARGE_ENTITY_ID;

export const CLAIMS_ENTITY_ID = "4";

export const isClaimsVisible = (): boolean =>
  getEntity().id === CLAIMS_ENTITY_ID;

export const NOTIFICATIONS_SHORT_LABEL_ENTITY_ID = "5";

export const getNotificationsLabel = (): string =>
  getEntity().id === NOTIFICATIONS_SHORT_LABEL_ENTITY_ID
    ? "reminder"
    : MENU.NOTIFICATIONS.LABEL;

